import { render } from "./MyAuctionsWidget.vue?vue&type=template&id=8601024e&scoped=true&ts=true"
import script from "./MyAuctionsWidget.vue?vue&type=script&lang=ts"
export * from "./MyAuctionsWidget.vue?vue&type=script&lang=ts"

import "./MyAuctionsWidget.vue?vue&type=style&index=0&id=8601024e&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8601024e"]])

export default __exports__